module.exports = __webpack_public_path__ + "static/media/4.3cd31aa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/4.png
// module id = 39
// module chunks = 0